import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import StudentTopMenu from './studenttopmenu'
import StudentInfoBox from './studentinfobox'
import { useParams } from 'react-router-dom'
import FeatherIcon from 'feather-icons-react'
import { getStudentIdData } from '../../../lib/studentpersonalanswerview'

export default function AdminStudentPersonalQuestion() {
  const [studentInfo, setStudentInfo] = useState()
  const [questionlist, setQuestionlist] = useState([])

  let { slug } = useParams()

  async function GetData() {
    const qustions = await getStudentIdData(slug)
    setQuestionlist(qustions)
    console.log('qustions', qustions)
  }

  useEffect(() => {
    GetData()
  }, [])
  return (
    <div className='col-12'>
      <div className='tak-instruct-group'>
        <div className='row'>
          <div className='col-md-12'>
            <StudentInfoBox slug={slug} />
            <StudentTopMenu slug={slug} activeMenu={'PersonalQuestions'} />
            <div className='settings-widget'>
              <div className='settings-inner-blk p-0'>
                <div className='checkout-form personal-address add-course-info'>
                  <div className='personal-info-head'>
                    <h4>Personal Questions List</h4>
                  </div>
                  <div className='comman-space pb-0'>
                    {questionlist.map(function (data) {
                      return (
                        <div
                          className='comman-space bdr-bottom-line'
                          key={data.questionId}
                        >
                          <div className='instruct-review-blk '>
                            <div className='review-item'>
                              <div className='instructor-wrap border-0 m-0'>
                                <div className='about-instructor'>
                                  <div className='instructor-detail'>
                                    <h5>{data.pname}</h5>
                                  </div>
                                </div>
                              </div>
                              <p className='rev-info'>
                                “ {data.studentAnswer} “
                              </p>
                              <Link
                                to={`/admin/admin-studentpersonalquestion-edit/${data.id}`}
                                className='btn btn-reply'
                              >
                                <FeatherIcon icon='corner-up-left' />
                                Respond
                              </Link>
                            </div>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
